import type { WeatherCondition } from "@/types";

interface WeatherGlyphProps {
  condition: WeatherCondition | string;
  size?: number;
}

export function WeatherGlyph({ condition, size = 22 }: WeatherGlyphProps) {
  const s = size;
  switch (condition) {
    case "sun": return (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="4.5" fill="oklch(0.85 0.15 75)" />
        <g stroke="oklch(0.78 0.16 75)" strokeWidth="1.8" strokeLinecap="round">
          <line x1="12" y1="2" x2="12" y2="5" />
          <line x1="12" y1="19" x2="12" y2="22" />
          <line x1="2" y1="12" x2="5" y2="12" />
          <line x1="19" y1="12" x2="22" y2="12" />
          <line x1="4.6" y1="4.6" x2="6.7" y2="6.7" />
          <line x1="17.3" y1="17.3" x2="19.4" y2="19.4" />
          <line x1="4.6" y1="19.4" x2="6.7" y2="17.3" />
          <line x1="17.3" y1="6.7" x2="19.4" y2="4.6" />
        </g>
      </svg>
    );
    case "night": return (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none">
        <path
          d="M 15.5 3.2 A 8.5 8.5 0 1 0 20.8 15.8 A 6.8 6.8 0 1 1 15.5 3.2 Z"
          fill="oklch(0.82 0.06 250)"
          stroke="oklch(0.63 0.05 245)"
          strokeWidth="1.4"
        />
      </svg>
    );
    case "heat": return (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none">
        <circle cx="13" cy="11" r="5" fill="oklch(0.78 0.18 60)" />
        <g stroke="oklch(0.7 0.18 55)" strokeWidth="1.8" strokeLinecap="round">
          <line x1="13" y1="2" x2="13" y2="4" />
          <line x1="22" y1="11" x2="20" y2="11" />
          <line x1="6" y1="4.5" x2="7.5" y2="6" />
        </g>
        <path d="M 3 19 Q 6 17 9 19 T 15 19 T 21 19" stroke="oklch(0.7 0.16 50)" strokeWidth="1.6" fill="none" strokeLinecap="round" />
      </svg>
    );
    case "cloud": return (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none">
        <path d="M 6 17 Q 3 17 3 14 Q 3 11 6 11 Q 7 7 11 7 Q 14 7 15.5 10 Q 19 10 19 13 Q 19 17 16 17 Z"
              fill="oklch(0.93 0.01 240)" stroke="oklch(0.65 0.02 230)" strokeWidth="1.5" />
      </svg>
    );
    case "rain": return (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none">
        <path d="M 6 13 Q 3 13 3 10 Q 3 7 6 7 Q 7 4 11 4 Q 14 4 15.5 7 Q 19 7 19 10 Q 19 13 16 13 Z"
              fill="oklch(0.88 0.01 240)" stroke="oklch(0.55 0.04 230)" strokeWidth="1.5" />
        <g stroke="oklch(0.55 0.1 235)" strokeWidth="1.8" strokeLinecap="round">
          <line x1="8" y1="16" x2="7" y2="20" />
          <line x1="12" y1="17" x2="11" y2="21" />
          <line x1="16" y1="16" x2="15" y2="20" />
        </g>
      </svg>
    );
    case "storm": return (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none">
        <path d="M 6 13 Q 3 13 3 10 Q 3 7 6 7 Q 7 4 11 4 Q 14 4 15.5 7 Q 19 7 19 10 Q 19 13 16 13 Z"
              fill="oklch(0.78 0.02 240)" stroke="oklch(0.5 0.04 230)" strokeWidth="1.5" />
        <path d="M 11 14 L 8 19 L 11 19 L 9 23 L 14 17 L 11 17 Z"
              fill="oklch(0.85 0.15 90)" stroke="oklch(0.65 0.13 75)" strokeWidth="1" />
      </svg>
    );
    case "wind": return (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="oklch(0.55 0.04 230)" strokeWidth="1.8" strokeLinecap="round">
        <path d="M 3 9 H 14 Q 17 9 17 6 Q 17 3 14 3" />
        <path d="M 3 15 H 18 Q 21 15 21 18 Q 21 21 18 21" />
        <path d="M 3 12 H 11" />
      </svg>
    );
    case "frost": return (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="oklch(0.6 0.04 230)" strokeWidth="1.8" strokeLinecap="round">
        <line x1="12" y1="3" x2="12" y2="21" />
        <line x1="3" y1="12" x2="21" y2="12" />
        <line x1="6" y1="6" x2="18" y2="18" />
        <line x1="6" y1="18" x2="18" y2="6" />
      </svg>
    );
    case "cold": return (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="oklch(0.55 0.05 235)" strokeWidth="1.8" strokeLinecap="round">
        <line x1="12" y1="4" x2="12" y2="20" />
        <line x1="4" y1="12" x2="20" y2="12" />
        <polyline points="8,8 12,4 16,8" />
        <polyline points="8,16 12,20 16,16" />
      </svg>
    );
    default: return (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="oklch(0.6 0.02 230)" strokeWidth="1.8" strokeLinecap="round">
        <line x1="3" y1="9" x2="17" y2="9" />
        <line x1="6" y1="13" x2="21" y2="13" />
        <line x1="3" y1="17" x2="14" y2="17" />
      </svg>
    );
  }
}
